'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../../_virtual/_rollupPluginBabelHelpers.js');

/** @const {string} Name of cookie-layer cookie */

var layerCookieName = 'vrt-cookie-layer';
/** @const {array} Level of cookie permissions */

var PERMISSIONS = {
  required: 'required',
  analytics: 'analytics',
  marketing: 'marketing'
};
/**
 * Returns the value of a specific cookie
 *
 * @param {string} name - Name of cookie
 * @param {Object} req - HTTP request object (server only)
 *
 * @returns {String} Value of the cookie
 */

function readCookie(name, req) {
  if (req && req.headers && req.headers.cookie) {
    var regex = new RegExp("".concat(name, "=([^;]*)")),
        _ref = req.headers.cookie.match(regex) || [],
        _ref2 = _rollupPluginBabelHelpers.slicedToArray(_ref, 2),
        value = _ref2[1];

    return value;
  } else if (typeof document === 'undefined') {
    return undefined;
  }

  var nameEQ = "".concat(name, "="),
      ca = document.cookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }

    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }

  return undefined;
}
/**
 * Writes a cookie
 *
 * @param {string} name - Name of cookie
 * @param {string} value - Value of cookie
 * @param {string} days - TTL of cookie in days
 * @param {Object} res - HTTP response object (server only)
 */

function createCookie(name, value, days, res) {
  if (res && res.cookie) {
    if (typeof value === 'undefined' && typeof days === 'undefined') {
      res.cookie(name);
    } else {
      res.cookie(name, value, {
        maxAge: days * 24 * 60 * 60 * 1000,
        encode: String
      });
    }
  } else if (typeof document !== 'undefined') {
    var expires = '';

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=".concat(date.toUTCString());
    }

    if (typeof value === 'undefined' && typeof days === 'undefined') {
      document.cookie = name;
    } else {
      document.cookie = "".concat(name, "=").concat(value).concat(expires, "; path=/");
    }
  }
}

exports.PERMISSIONS = PERMISSIONS;
exports.createCookie = createCookie;
exports.layerCookieName = layerCookieName;
exports.readCookie = readCookie;
